import { Pipe, PipeTransform } from '@angular/core';
import { StatusService } from '@bo-client/shared/status/status.service';

/** Bezeichnung bzw. Farbe (`'cssColor'`) des Status einer Hausanschluss-Anfrage (`OrderRequest.state`). */
@Pipe({
  name: 'offerState',
  pure: false
})
export class OfferStatePipe implements PipeTransform {
  constructor(private statusService: StatusService) {}
  transform(value: string, args?: 'displayName' | 'cssColor'): string {
    if (!value) return '';
    const state = this.statusService.find('orderRequests', value);
    if (!state) return value;
    return args === 'cssColor' ? state.cssColor || '#71dde3' : state.displayName;
  }
}
